import { put, takeLatest, fork } from 'redux-saga/effects';

import {
    OPEN_BANKING_MODAL,
    OPEN_BANKING_MODAL_DATA,
    CLOSE_BANKING_MODAL
} from './LinkOpenBankingModal.actions';
import { selectAPI } from '../../../api/API.sagas';
import { OPEN_MODAL, CLOSE_MODAL } from '../../../iwModals/Modals.actions';

export const linkOpenBankingModalWorkers = [
    fork(openLinkOpenBankingModal),
    fork(closeLinkOpenBankingModal)
];

function* openLinkOpenBankingModal() {
    yield takeLatest(OPEN_BANKING_MODAL, function* () {
        const { site_context } = yield selectAPI();

        yield put({ type: OPEN_BANKING_MODAL_DATA, site_context });

        yield put({
            type: OPEN_MODAL,
            id: 'LinkOpenBankingModal'
        });
    });
}

function* closeLinkOpenBankingModal() {
    yield takeLatest(CLOSE_BANKING_MODAL, function* () {
        yield put({ type: CLOSE_MODAL });
    });
}
